import { tryJsonParse } from '../../../../../utils';
import { GetVisualizationResponse, GetVisualizationResponseV2 } from '../models';

const mapVisualizationV2ToV1 = (visualization?: GetVisualizationResponseV2): GetVisualizationResponse | undefined => {
    if (!visualization) return undefined;
    const {
        id,
        user_id,
        query_id,
        type,
        title,
        subtitle,
        description,
        config,
        obscured_screenshot_url,
        created_at,
        updated_at,
        tag_ids,
        query,
        user,
    } = visualization ?? ({} as any);
    const { last_execution_cache, title: queryTitle, slug: querySlug } = query ?? ({} as any);

    return {
        data: {
            id: String(id),
            userId: String(user_id),
            queryId: String(query_id),
            type,
            title,
            subTitle: subtitle,
            description,
            config: tryJsonParse(config).parsedJson,
            obscuredScreenshotUrl: obscured_screenshot_url,
            createdAt: created_at,
            updatedAt: updated_at,
            tagIds: tag_ids?.map(id => String(id)) ?? [],
            executionEndedAt: last_execution_cache?.execution_ended_at,
            executionState: last_execution_cache?.state,
            lastExecutionId: String(last_execution_cache?.execution_id ?? ''),
            queryTitle,
            querySlug,
            userName: user?.name ?? '',
            userEmail: user?.email ?? '',
        },
        _meta: {
            total: 1,
            message: undefined,
            success: true,
        },
    };
};

export { mapVisualizationV2ToV1 };
